import React, { useEffect, useRef, useState } from "react";

const collapsedContentStyle = {
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 4,
  overflow: "hidden",
};

const ExpandableFieldValue = ({ value }) => {
  const contentRef = useRef(null);
  const [isExpandable, setIsExpandable] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(false);
  }, [value]);

  useEffect(() => {
    const element = contentRef.current;
    if (!element || typeof window === "undefined") {
      return undefined;
    }

    const measure = () => {
      const computedStyle = window.getComputedStyle(element);
      const fontSize = Number.parseFloat(computedStyle.fontSize) || 16;
      const lineHeight = Number.parseFloat(computedStyle.lineHeight) || fontSize * 1.5;
      const collapsedHeight = lineHeight * 4 + 1;
      setIsExpandable(element.scrollHeight > collapsedHeight);
    };

    const animationFrameId = window.requestAnimationFrame(measure);

    if (typeof ResizeObserver === "function") {
      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(element);

      return () => {
        window.cancelAnimationFrame(animationFrameId);
        resizeObserver.disconnect();
      };
    }

    window.addEventListener("resize", measure);

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", measure);
    };
  }, [value]);

  return (
    <div className="flex flex-col gap-2 md:max-w-[70%] md:items-end">
      <p
        ref={contentRef}
        style={isExpandable && !isExpanded ? collapsedContentStyle : undefined}
        className="whitespace-pre-wrap break-words text-sm leading-6 text-slate-100 md:text-right"
      >
        {value}
      </p>

      {isExpandable ? (
        <button
          type="button"
          onClick={() => setIsExpanded((currentValue) => !currentValue)}
          className="inline-flex items-center rounded-full border border-slate-700 bg-slate-900/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-300 transition-colors hover:border-slate-500 hover:text-white"
        >
          {isExpanded ? "Show less" : "Show more"}
        </button>
      ) : null}
    </div>
  );
};

export default ExpandableFieldValue;
